import { getCookie } from 'cookies-next';

import { clientAxios } from '../api';
import { PATH } from '../constants';

class Auth {
  static getDomain() {
    const stage = process.env.NEXT_PUBLIC_APP_STAGE;
    if (stage === 'prod') return '.wishket.com';
    if (stage === 'stag') return '.wishdev.net';
    if (stage === 'dev') return '.wishdev.net';

    return 'localhost';
  }

  static async refreshAccessToken() {
    try {
      const WART = getCookie('WART');
      if (!WART) return null;

      const wsessionid = getCookie('wsessionid');
      if (!wsessionid) return null;

      const { data } = await clientAxios.put(
        `${PATH.WISHKET_OIDC_URL}?wishketOidcOrigin=${encodeURIComponent(process.env.NEXT_PUBLIC_APP_BASE_URL || '')}`,
        {},
        {
          headers: {
            cookie: `WART=${WART};wsessionid=${wsessionid}`,
          },
          withCredentials: true,
        }
      );

      return data.ok;
    } catch (e) {
      return null;
    }
  }
}

export default Auth;
